var Sharer = require('sharer.npm.js');

var Sharing = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

Sharing.prototype.init = function(){

  // binding to events
  this.options.$el.find("a.share").on("click", function(){
    var sharer = new Sharer(this)
    sharer.share();
  })

  let $pdfDownloadLink = this.options.$el.find(`.pdf-download-link`);

  $pdfDownloadLink.on('click', function() {

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'download_pdf',
		event_category: 'engagement'
	});

  });

};

export default  Sharing;
